module.exports = __webpack_public_path__ + "static/media/rest-api.62c17701.svg";